import React, { useState, useEffect } from 'react'
import { doneLoading, startLoading } from '../../../utils/loading'
import ClosureRequestAssetTable from './ClosureRequestAssetTable'
import ClosureRequestAssetSearchForm from './ClosureRequestAssetSearchForm'
import { getAssetList, searchAssetList } from '../../../redux/actions/accountingAssetClosure'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { cloneDeep } from 'lodash'
import { Panel } from 'rsuite'

export default function ClosureRequestAssetWidget({
  loading,
  Controller,
  register,
  control,
  errors,
  setValue,
  getValues,
  setError,
  clearErrors,
  onSelected,
  selectManageType = () => {},
  searchRequestBody,
  ...props
}) {
  const { projectCode } = props

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState()
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [searchRequest, setSearchRequest] = useState({})

  useEffect(() => {
    // handleLoad(1, 5)
    handleLoad(0, 0)
  }, [])

  const handleLoad = async (pagenumber, pagesize) => {
    setIsLoading(true)
    startLoading()
    try {
      setPage(pagenumber)
      setDisplayLength(pagesize)
      setSearchRequest({})

      const response = await getAssetList(projectCode, pagenumber, pagesize)
      // console.log('handleLoad ', response)

      setFormSchema(response.model)
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSearch = async (pagenumber, pagesize, request) => {
    setIsLoading(true)
    startLoading()
    try {
      setPage(pagenumber)
      setDisplayLength(pagesize)
      setSearchRequest(request)

      const response = await searchAssetList(request, projectCode, pagenumber, pagesize)
      // console.log('response ', response)
      var _schema = cloneDeep(formSchema)

      _schema.form.result = response.model

      setFormSchema(_schema)
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onReload = (pagenumber, pagesize) => {
    handleSearch(pagenumber, pagesize, searchRequest)
  }

  const onSearch = (request) => {
    handleSearch(1, displayLength, request)
    searchRequestBody(request)
  }

  // const handleSelectedItemTable = (chk) => {
  //   console.log('handleSelectedItemTable ', chk)
  //   setListItemSelected(chk)
  // }

  return (
    <>
      {formSchema?.form && (
        <>
          {formSchema.form?.searchForm && (
            <div style={{ marginTop: 20 }}>
              <ClosureRequestAssetSearchForm
                schema={formSchema.form.searchForm}
                onSearch={onSearch}
                loading={isLoading}
              />
            </div>
          )}

          <Panel
            bordered
            collapsible
            defaultExpanded
            header={`ผลการค้นหา`}
            style={{ marginTop: 10 }}
          >
            <div style={{ marginTop: -20 }}>
              <ClosureRequestAssetTable
                schema={formSchema.form?.result}
                loading={isLoading}
                onReload={onReload}
                page={page}
                displayLength={displayLength}
                // onSelected={onSelected}
                selectedItem={onSelected}
                onSelectManageType={selectManageType}
                Controller={Controller}
                register={register}
                control={control}
                errors={errors}
                setValue={setValue}
                getValues={getValues}
                setError={setError}
                clearErrors={clearErrors}
              />
            </div>
          </Panel>
        </>
      )}
    </>
  )
}
